import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TipuriDocumente, TipuriDocumenteEditPayload } from './tipuri-documente.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TipuriDocumenteService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private getTipuriDocumenteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii.getTipuri;
    private storeTipuriDocumentUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii.storeTip;

    private deleteTipuriDocumenteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii.deleteTip;

    private getTipuriDocumenteActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii
            .getTipuriActive;

    private getTipuriDocumentePublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii
            .getTipuriPublic;

    private updateTipuriDocumenteUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii.updateTipuri;

    private updateOrderUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii.updateOrder;


    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii
            .changeStatusTipuriActive;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.platform.nomenclatoare.tipuriDocumenteInstitutii
            .changeStatusTipuriPublic;

    constructor(private http: HttpClient) { }

    addTip(data: TipuriDocumente) {
        return this.http.post(this.storeTipuriDocumentUrl, data, this.httpOptions);
    }

    getTipuriDocumente() {
        return this.http.get(this.getTipuriDocumenteUrl, this.httpOptions);
    }

    getTipuriDocumenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getTipuriDocumenteActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in get tipuri documente active:', error);
                    return throwError(error);
                })
            );
    }

    getTipuriDocumentePublic() {
        return this.http.get(this.getTipuriDocumentePublicUrl, this.httpOptions);
    }

    updateTip(data: TipuriDocumenteEditPayload) {
        return this.http.put(this.updateTipuriDocumenteUrl, data, this.httpOptions);
    }

    deleteTip(id: number) {
        return this.http.delete(this.deleteTipuriDocumenteUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    updateOrder(id: number, data: any) {
        return this.http.put(this.updateOrderUrl + id, data, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }
}
